(function($, Cobalt, undefined) {
    var defaultLanguageID = 1; // English

    var handlePluralization = (function() {
        var pluralizers = {
            0: function(number, forms) { // Asian (Chinese, Japanese, Korean, Vietnamese), Persian, Turkic/Altaic (Turkish), Thai, Lao// Asian (Chinese, Japanese, Korean, Vietnamese), Persian, Turkic/Altaic (Turkish), Thai, Lao
                return forms[0];
            },
            1: function(number, forms) { // Germanic (Danish, Dutch, English, Faroese, Frisian, German, Norwegian, Swedish), Finno-Ugric (Estonian, Finnish, Hungarian), Language isolate (Basque), Latin/Greek (Greek), Semitic (Hebrew), Romanic (Italian, Portuguese, Spanish, Catalan)
                if (number == 1) { // is 1
                    return forms[0];
                } else {
                    return forms[1];
                }
            },
            2: function(number, forms) { // Romanic (French, Brazilian Portuguese)
                if (number == 1 || number == 0) { // is 1 or 0
                    return forms[0];
                } else {
                    return forms[1];
                }
            },
            3: function(number, forms) { // Baltic (Latvian)
                if (forms.length < 3 || number == 0) { // is 0
                    return forms[0];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[2];
                } else if (number % 10 == 1 && number % 100 != 11) { // ends in 1, not 11
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            4: function(number, forms) { // Celtic (Scottish Gaelic)
                if (forms.length < 3 || number == 1) { // is 1
                    return forms[0];
                } else if (number == 2) { // is 2
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            5: function(number, forms) { // Romanic (Romanian)
                if (forms.length < 3 || number == 1) { // is 1
                    return forms[0];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[2];
                } else if (number == 0 || (number % 100 >= 1 && number % 100 <= 19)) { // is 0 or ends in 01-19
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            6: function(number, forms) { // Baltic (Lithuanian)
                if (forms.length < 3 || (number % 10 == 1 && number % 100 != 11)) { // ends in 1, not 11
                    return forms[0];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[2];
                } else if (number % 10 == 0 || (number % 100 >= 10 && number % 100 <= 20)) { // ends in 0 or ends in 10-20
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            7: function(number, forms) { // Slavic (Croatian, Serbian, Russian, Ukrainian)
                if (forms.length < 3 || (number % 10 == 1 && number % 100 != 11)) { // ends in 1, not 11
                    return forms[0];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[2];
                } else if ((number % 10 >= 2 && number % 10 <= 4) && !(number % 100 >= 12 && number % 100 <= 14)) { // ends in 2-4, not 12-14
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            8: function(number, forms) { // Slavic (Slovak, Czech)
                if (forms.length < 3 || number == 1.0) { // is 1
                    return forms[0];
                } else if (number % 1.0 != 0.0) { // non-integer
                    return forms[2];
                } else if (number % 10.0 >= 2.0 && number % 10.0 <= 4.0) { // ends in 2-4
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            9: function(number, forms) { // Slavic (Polish)
                if (forms.length < 3 || number == 1) { // is 1
                    return forms[0];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[2];
                } else if ((number % 10 >= 2 && number % 10 <= 4.0) && !(number % 100 >= 12 && number % 100 <= 14)) { // ends in 2-4, not 12-14
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            10: function(number, forms) { // Slavic (Slovenian, Sorbian)
                if (forms.length < 4 || number % 100 == 1) { // ends in 01
                    return forms[0];
                } else if (number % 100 == 2) { // ends in 02
                    return forms[1];
                } else if (number % 100 == 3 || number % 100 == 4) { // ends in 03 or 04
                    return forms[2];
                } else {
                    return forms[3];
                }
            },
            11: function(number, forms) { // Celtic (Irish Gaeilge)
                if (forms.length < 5 || number == 1) { // is 1
                    return forms[0];
                } else if (number == 2.0) { // is 2
                    return forms[1];
                } else if (number % 1.0 != 0.0) { // non-integer
                    return forms[4];
                } else if (number >= 3.0 && number <= 6.0) { // is 3-6
                    return forms[2];
                } else if (number >= 7.0 && number <= 10.0) { // is 7-10
                    return forms[3];
                } else {
                    return forms[4];
                }
            },
            12: function(number, forms) { // Semitic (Arabic)
                if (forms.length < 6 || number == 1) { // is 1
                    return forms[0];
                } else if (number == 2) { // is 2
                    return forms[1];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[4];
                } else if (number % 100 >= 3 && number % 100 <= 10) { // ends in 03-10
                    return forms[2];
                } else if (number % 100 >= 11 && number % 100 <= 99) { // ends in 11-99
                    return forms[3];
                } else if (number == 0) { // is 0
                    return forms[5];
                } else {
                    return forms[4];
                }
            },
            13: function(number, forms) { // Semitic (Maltese)
                if (forms.length < 4 || number == 1) { // is 1
                    return forms[0];
                } else if (number % 1.0 != 0) { // non-integer
                    return forms[3];
                } else if (number == 0 || (number % 100 >= 1 && number % 100 <= 10)) { // is 0 or ends in 01-10
                    return forms[1];
                } else if (number % 100 >= 11 && number % 100 <= 19) { // ends in 11-19
                    return forms[2];
                } else {
                    return forms[3];
                }
            },
            14: function(number, forms) { // Slavic (Macedonian)
                if (forms.length < 3 || number % 10.0 == 1.0) { // ends in 1
                    return forms[0];
                } else if (number % 10.0 != 2.0) { // ends in 2
                    return forms[1];
                } else {
                    return forms[2];
                }
            },
            15: function(number, forms) { // Icelandic
                if (number % 10.0 == 1.0 && number % 100.0 != 11.0) { // ends in 1, but not 11
                    return forms[0];
                } else {
                    return forms[1];
                }
            }
        };

        var pluralRegex = /PLURAL\[([^\]]+)\]/g;
        return function(pluralForm, text) {
            if (!text) {
                return "";
            }
            return text.replace(pluralRegex, function(full, value) {
                var results = value.split(';');
                if (results.length < 2) {
                    return "";
                } else if (results.length == 2) {
                    return results[1];
                }

                var number = parseFloat(results[0]);
                if (number != number) { // not a number
                    number = 0.0;
                }
                results.shift(); // pop the first value off

                return pluralizers[pluralForm](number, results);
            });
        }
    })();

    Cobalt.Localization = function(isMain) {
        if (isMain) {
            Cobalt.Localization.Main = this;
        }
        var currentLanguageID = 1; // English

        var languages = {};

        var getPluralFormByLanguageIDCache = {};
        var getPluralFormByLanguageID = function(languageID) {
            var pluralForm = getPluralFormByLanguageIDCache[languageID];
            if (typeof pluralForm == "undefined") {
                pluralForm = 0; // Asian-style
                for (var i = 0; i < languages.length; i++) {
                    var data = languages[i];
                    if (data.id == languageID) {
                        pluralForm = data.pluralForm;
                        break;
                    }
                }
                getPluralFormByLanguageIDCache[languageID] = pluralForm;
            }
            return pluralForm;
        }

        this.getCurrentLanguageID = function() {
            return currentLanguageID;
        }

        this.setCurrentLanguageID = function(value) {
            currentLanguageID = value;
        }

        this.setLanguages = function(value) {
            getPluralFormByLanguageIDCache = {};
            languages = value;
            this.Languages = value;
        }

        this.populate = function(languageID, data) {
            for (var ns in data) {
                for (var sub in data[ns]) {
                    for (var phrase in data[ns][sub]) {
                        if (this[ns] && this[ns][sub] && this[ns][sub][phrase]) {
                            this[ns][sub][phrase][languageID] = data[ns][sub][phrase];
                        }
                    }
                }
            }
        }

        this.localize = function(data) {
            var func = data.callee;
            var languageID = currentLanguageID;
            var result = func[languageID];
            if (typeof result == "undefined" && currentLanguageID != defaultLanguageID) {
                languageID = defaultLanguageID;
                result = func[languageID];
                if (typeof result == "undefined") {
                    throw "Can't find translation.";
                }
            }

            if (data.length > 0) {
                result = String.prototype.format.apply(result, data);
            }

            var pluralForm = getPluralFormByLanguageID(languageID);
            return handlePluralization(pluralForm, result);
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Localization.js